var Uint32 = (function () {
    function Uint32(value) {
        this.array = Uint32Array.from([value]);
    }
    Object.defineProperty(Uint32.prototype, "length", {
        get: function () { return this.array.length; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Uint32.prototype, "value", {
        get: function () { return this.array[0]; },
        enumerable: true,
        configurable: true
    });
    ;
    return Uint32;
}());
export { Uint32 };
;
//# sourceMappingURL=uint32.js.map